import { useMutation } from "urql";
import {
  DeleteCrewMutationMutation,
  DeleteCrewMutationMutationVariables,
} from "../gql/graphql";
import { TypedDocumentNode } from "@graphql-typed-document-node/core";
import { graphql } from "../gql";

export function useDeleteCrewMutation() {
  return useMutation(deleteCrewMutation);
}

export const deleteCrewMutation: TypedDocumentNode<
  DeleteCrewMutationMutation,
  DeleteCrewMutationMutationVariables
> = graphql(`
  mutation deleteCrewMutation($identifier: String!, $bucket: String!) {
    deleteCrew(identifier: $identifier, bucket: $bucket)
  }
`);
